import React from 'react';
export function Footer() {
  return <footer className="bg-navy-deep border-t border-gold/30 py-10 px-4 text-center" data-id="element-86" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white/60" data-id="element-87" data-mp="3gg0zo4mhnzy6">
        © Taekwondo Instructor Ready 2026 — All rights reserved.
      </p>
    </footer>;
}